<nav class="navbar navbar-expand-lg navbar-dark ">
  <div class="container-fluid">
    <a class="navbar-brand" href="#"></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ms-md-auto gap-2">
        <li class="nav-item rounded">
          <a class="nav-link active" routerLink="/Home" routerLinkActive="active"  aria-current="page" aria-selected="true" ><i class="bi bi-house-fill me-2"></i>Home</a>
        </li>
       
        <li class="nav-item dropdown rounded">
          <a class="nav-link" routerLink="/project" id="navbarDropdown" routerLinkActive="active" role="button"  aria-expanded="false" aria-selected="false"><i class="bi bi-people-fill me-2"></i>Projects</a>
        </li> 
        <li class="nav-item rounded">
          <a class="nav-link" routerLink="/contact"  routerLinkActive="active" aria-selected="false"><i class="bi bi-telephone-fill me-2"></i>Contact</a>
        </li>
        <li class="nav-item rounded" style="background-color:rgb(126, 24, 121); border:none;">
          <a class="nav-link" href="https://drive.google.com/file/d/1WU9vy1sJWtO4aUjwCuznVJhhU2gEQzLF/view?usp=sharings"><i class="bi bi-file-earmark-person me-2" aria-selected="false"></i>Resumer</a>
        </li>
     
    
      
        
      </ul>
    </div>
  </div>
</nav>
<section id="banner">
  <div class="container" data-aos="fade-left">
      <div class="row">
          <div class="col-md-6 ">
              <p class="banner-designer">Front-End Developer 👋</p>
              <p class="text-sm-left text-uppercase content">Hi,I'm <span class="bg-white text-black"> amine akchouche </span>. A passionat Front end developer <br> specialize in <span class="bg-white text-black">transforming ideas into visually stunning </span> <br> and <span class="bg-white text-black"> seamlessly functional websites. </span></p>
              <a href="https://www.youtube.com/c/CodingZone/about" target="_blank" class="btn btn-primary">
                <i class="bi bi-play"></i> 
                <span class="ml-2"> Check Content</span>
              </a>
          </div>
          <div class="col-md-6 text-center">
<img src="../../assets/idée.svg"  data-aos="fade-left" class="img-fluid" alt="">
          </div>
      </div>
  </div>
 <img src="../../assets/wave1.png" alt=""> 
</section>




